{
  "version": 2,
  "basePath": "/cdn/v2/plugins",
  "defaults": [
    "consent",
    "gcm",
    "presence",
    "router",
    "engagement",
    "scroll",
    "click",
    "download",
    "forms",
    "ecommerce",
    "video",
    "bot",
    "webvitals",
    "perf",
    "adblock",
    "session_quality",
    "experiments",
    "identitylink",
    "identityopportunity",
    "identitystorage",
    "intent",
    "journey",
    "errors",
    "diagnostics",
    "outbound",
    "attribution",
    "shopify",
    "firstparty",
    "search",
    "impressions",
    "destinations"
  ],
  "plugins": {
    "consent": { "path": "consent.js", "deps": [], "tier": "essential" },
    "gcm": { "path": "gcm.js", "deps": ["consent"], "tier": "essential" },
    "presence": { "path": "presence.js", "deps": [], "tier": "essential" },
    "router": { "path": "router.js", "deps": [], "tier": "early" },
    "engagement": { "path": "engagement.js", "deps": [], "tier": "late" },
    "scroll": { "path": "scroll.js", "deps": [], "tier": "late" },
    "click": { "path": "click.js", "deps": [], "tier": "early" },
    "download": { "path": "download.js", "deps": [], "tier": "late" },
    "forms": { "path": "forms.js", "deps": [], "tier": "late" },
    "ecommerce": {
      "path": "ecommerce.js",
      "deps": [],
      "kind": "marketing",
      "tier": "late"
    },
    "video": { "path": "video.js", "deps": [], "tier": "late" },
    "bot": { "path": "bot.js", "deps": [], "tier": "early" },
    "webvitals": { "path": "webvitals.js", "deps": [], "tier": "early" },
    "perf": { "path": "perf.js", "deps": [], "tier": "early" },
    "adblock": { "path": "adblock.js", "deps": [], "tier": "early" },
    "session_quality": {
      "path": "session_quality.js",
      "deps": [],
      "tier": "early"
    },
    "experiments": {
      "path": "experiments.js",
      "deps": [],
      "tier": "early"
    },
    "identitylink": {
      "path": "identitylink.js",
      "deps": [],
      "kind": "marketing",
      "tier": "early"
    },
    "identityopportunity": {
      "path": "identityopportunity.js",
      "deps": [],
      "tier": "essential"
    },
    "identitystorage": {
      "path": "identitystorage.js",
      "deps": [],
      "kind": "marketing",
      "tier": "idle"
    },
    "intent": {
      "path": "intent.js",
      "deps": [],
      "kind": "marketing",
      "tier": "early"
    },
    "journey": {
      "path": "journey.js",
      "deps": [],
      "kind": "marketing",
      "tier": "early"
    },
    "errors": { "path": "errors.js", "deps": [], "tier": "early" },
    "diagnostics": {
      "path": "diagnostics.js",
      "deps": [],
      "tier": "essential"
    },
    "outbound": {
      "path": "outbound.js",
      "deps": ["click"],
      "kind": "marketing",
      "tier": "early"
    },
    "attribution": {
      "path": "attribution.js",
      "deps": ["router"],
      "kind": "marketing",
      "tier": "early"
    },
    "firstparty": {
      "path": "firstparty.js",
      "deps": [],
      "kind": "marketing",
      "tier": "early"
    },
    "shopify": {
      "path": "shopify.js",
      "deps": [],
      "kind": "marketing",
      "tier": "late"
    },
    "search": {
      "path": "search.js",
      "deps": [],
      "kind": "marketing",
      "tier": "late"
    },
    "impressions": {
      "path": "impressions.js",
      "deps": [],
      "tier": "late"
    },
    "destinations": {
      "path": "destinations.js",
      "deps": [],
      "kind": "marketing",
      "tier": "idle"
    },
    "redact": { "path": "redact.js", "deps": [], "tier": "late" },
    "ratelimit": { "path": "ratelimit.js", "deps": [], "tier": "late" },
    "heatmap": { "path": "heatmap.js", "deps": [], "tier": "idle" },
    "replay": { "path": "replay.js", "deps": [], "tier": "idle" }
  }
}
